// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.RentalManagerUserInfoWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { RentalManagerAuthCheckUserInfoDto } from '../..';

interface GetParams {
  allowedSessionLengthSeconds?: number;
  extendSession?: boolean;
  includeCanClaimFreeListings?: boolean;
  includeCustomers?: boolean;
  includePrivileges?: boolean;
  includeProfileImageUrl?: boolean;
  includeSummary?: string;
  pageWithSensitiveInformation?: string;
}

export const RentalManagerUserInfoWebApiHandler_get_Path = '/api/web/v1/users/get';

/**
 * Get data for a user; To be used by mobile apps only
 */
export const RentalManagerUserInfoWebApiHandler_get = (getParams: GetParams, client = getClient()) => {
  return httpFrontEndRequest<GetParams, never, RentalManagerAuthCheckUserInfoDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserInfoWebApiHandler_get_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
